//#region src/core/i18n/text/live.ts
const prefix = "live.";
const playingText = {
	key: `${prefix}playing`,
	text: "Playing live"
};
const seekToEdgeText = {
	key: `${prefix}seekToEdge`,
	text: "Seek to live edge"
};
const badgeText = {
	key: `${prefix}badge`,
	text: "Live"
};
//#endregion
export { badgeText, playingText, seekToEdgeText };

//# sourceMappingURL=live.js.map